// ISO 3166-1 nationalities (demonym) used by the traveler form.
// `code` = ISO-alpha-2; `name` = nationality adjective rendered on the passport
// data page; `country` = full country name (matched against searches too).
export const NATIONALITIES = [
  { code: "AF", name: "Afghan", country: "Afghanistan" },
  { code: "AL", name: "Albanian", country: "Albania" },
  { code: "DZ", name: "Algerian", country: "Algeria" },
  { code: "AD", name: "Andorran", country: "Andorra" },
  { code: "AO", name: "Angolan", country: "Angola" },
  { code: "AG", name: "Antiguan", country: "Antigua and Barbuda" },
  { code: "AR", name: "Argentine", country: "Argentina" },
  { code: "AM", name: "Armenian", country: "Armenia" },
  { code: "AU", name: "Australian", country: "Australia" },
  { code: "AT", name: "Austrian", country: "Austria" },
  { code: "AZ", name: "Azerbaijani", country: "Azerbaijan" },
  { code: "BS", name: "Bahamian", country: "Bahamas" },
  { code: "BH", name: "Bahraini", country: "Bahrain" },
  { code: "BD", name: "Bangladeshi", country: "Bangladesh" },
  { code: "BB", name: "Barbadian", country: "Barbados" },
  { code: "BY", name: "Belarusian", country: "Belarus" },
  { code: "BE", name: "Belgian", country: "Belgium" },
  { code: "BZ", name: "Belizean", country: "Belize" },
  { code: "BJ", name: "Beninese", country: "Benin" },
  { code: "BT", name: "Bhutanese", country: "Bhutan" },
  { code: "BO", name: "Bolivian", country: "Bolivia" },
  { code: "BA", name: "Bosnian", country: "Bosnia and Herzegovina" },
  { code: "BW", name: "Motswana", country: "Botswana" },
  { code: "BR", name: "Brazilian", country: "Brazil" },
  { code: "BN", name: "Bruneian", country: "Brunei" },
  { code: "BG", name: "Bulgarian", country: "Bulgaria" },
  { code: "BF", name: "Burkinabe", country: "Burkina Faso" },
  { code: "BI", name: "Burundian", country: "Burundi" },
  { code: "KH", name: "Cambodian", country: "Cambodia" },
  { code: "CM", name: "Cameroonian", country: "Cameroon" },
  { code: "CA", name: "Canadian", country: "Canada" },
  { code: "CV", name: "Cape Verdean", country: "Cape Verde" },
  { code: "CF", name: "Central African", country: "Central African Republic" },
  { code: "TD", name: "Chadian", country: "Chad" },
  { code: "CL", name: "Chilean", country: "Chile" },
  { code: "CN", name: "Chinese", country: "China" },
  { code: "CO", name: "Colombian", country: "Colombia" },
  { code: "KM", name: "Comoran", country: "Comoros" },
  { code: "CG", name: "Congolese", country: "Congo" },
  { code: "CR", name: "Costa Rican", country: "Costa Rica" },
  { code: "HR", name: "Croatian", country: "Croatia" },
  { code: "CU", name: "Cuban", country: "Cuba" },
  { code: "CY", name: "Cypriot", country: "Cyprus" },
  { code: "CZ", name: "Czech", country: "Czech Republic" },
  { code: "DK", name: "Danish", country: "Denmark" },
  { code: "DJ", name: "Djiboutian", country: "Djibouti" },
  { code: "DM", name: "Dominican", country: "Dominica" },
  { code: "DO", name: "Dominican", country: "Dominican Republic" },
  { code: "EC", name: "Ecuadorian", country: "Ecuador" },
  { code: "EG", name: "Egyptian", country: "Egypt" },
  { code: "SV", name: "Salvadoran", country: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinean", country: "Equatorial Guinea" },
  { code: "ER", name: "Eritrean", country: "Eritrea" },
  { code: "EE", name: "Estonian", country: "Estonia" },
  { code: "ET", name: "Ethiopian", country: "Ethiopia" },
  { code: "FJ", name: "Fijian", country: "Fiji" },
  { code: "FI", name: "Finnish", country: "Finland" },
  { code: "FR", name: "French", country: "France" },
  { code: "GA", name: "Gabonese", country: "Gabon" },
  { code: "GM", name: "Gambian", country: "Gambia" },
  { code: "GE", name: "Georgian", country: "Georgia" },
  { code: "DE", name: "German", country: "Germany" },
  { code: "GH", name: "Ghanaian", country: "Ghana" },
  { code: "GR", name: "Greek", country: "Greece" },
  { code: "GD", name: "Grenadian", country: "Grenada" },
  { code: "GT", name: "Guatemalan", country: "Guatemala" },
  { code: "GN", name: "Guinean", country: "Guinea" },
  { code: "GW", name: "Guinea-Bissauan", country: "Guinea-Bissau" },
  { code: "GY", name: "Guyanese", country: "Guyana" },
  { code: "HT", name: "Haitian", country: "Haiti" },
  { code: "HN", name: "Honduran", country: "Honduras" },
  { code: "HK", name: "Hong Konger", country: "Hong Kong" },
  { code: "HU", name: "Hungarian", country: "Hungary" },
  { code: "IS", name: "Icelander", country: "Iceland" },
  { code: "IN", name: "Indian", country: "India" },
  { code: "ID", name: "Indonesian", country: "Indonesia" },
  { code: "IR", name: "Iranian", country: "Iran" },
  { code: "IQ", name: "Iraqi", country: "Iraq" },
  { code: "IE", name: "Irish", country: "Ireland" },
  { code: "IL", name: "Israeli", country: "Israel" },
  { code: "IT", name: "Italian", country: "Italy" },
  { code: "CI", name: "Ivorian", country: "Ivory Coast" },
  { code: "JM", name: "Jamaican", country: "Jamaica" },
  { code: "JP", name: "Japanese", country: "Japan" },
  { code: "JO", name: "Jordanian", country: "Jordan" },
  { code: "KZ", name: "Kazakhstani", country: "Kazakhstan" },
  { code: "KE", name: "Kenyan", country: "Kenya" },
  { code: "KI", name: "I-Kiribati", country: "Kiribati" },
  { code: "KP", name: "North Korean", country: "North Korea" },
  { code: "KR", name: "South Korean", country: "South Korea" },
  { code: "KW", name: "Kuwaiti", country: "Kuwait" },
  { code: "KG", name: "Kyrgyz", country: "Kyrgyzstan" },
  { code: "LA", name: "Laotian", country: "Laos" },
  { code: "LV", name: "Latvian", country: "Latvia" },
  { code: "LB", name: "Lebanese", country: "Lebanon" },
  { code: "LS", name: "Mosotho", country: "Lesotho" },
  { code: "LR", name: "Liberian", country: "Liberia" },
  { code: "LY", name: "Libyan", country: "Libya" },
  { code: "LI", name: "Liechtensteiner", country: "Liechtenstein" },
  { code: "LT", name: "Lithuanian", country: "Lithuania" },
  { code: "LU", name: "Luxembourger", country: "Luxembourg" },
  { code: "MO", name: "Macanese", country: "Macao" },
  { code: "MK", name: "Macedonian", country: "North Macedonia" },
  { code: "MG", name: "Malagasy", country: "Madagascar" },
  { code: "MW", name: "Malawian", country: "Malawi" },
  { code: "MY", name: "Malaysian", country: "Malaysia" },
  { code: "MV", name: "Maldivian", country: "Maldives" },
  { code: "ML", name: "Malian", country: "Mali" },
  { code: "MT", name: "Maltese", country: "Malta" },
  { code: "MH", name: "Marshallese", country: "Marshall Islands" },
  { code: "MR", name: "Mauritanian", country: "Mauritania" },
  { code: "MU", name: "Mauritian", country: "Mauritius" },
  { code: "MX", name: "Mexican", country: "Mexico" },
  { code: "FM", name: "Micronesian", country: "Micronesia" },
  { code: "MD", name: "Moldovan", country: "Moldova" },
  { code: "MC", name: "Monegasque", country: "Monaco" },
  { code: "MN", name: "Mongolian", country: "Mongolia" },
  { code: "ME", name: "Montenegrin", country: "Montenegro" },
  { code: "MA", name: "Moroccan", country: "Morocco" },
  { code: "MZ", name: "Mozambican", country: "Mozambique" },
  { code: "MM", name: "Burmese", country: "Myanmar" },
  { code: "NA", name: "Namibian", country: "Namibia" },
  { code: "NR", name: "Nauruan", country: "Nauru" },
  { code: "NP", name: "Nepalese", country: "Nepal" },
  { code: "NL", name: "Dutch", country: "Netherlands" },
  { code: "NZ", name: "New Zealander", country: "New Zealand" },
  { code: "NI", name: "Nicaraguan", country: "Nicaragua" },
  { code: "NE", name: "Nigerien", country: "Niger" },
  { code: "NG", name: "Nigerian", country: "Nigeria" },
  { code: "NO", name: "Norwegian", country: "Norway" },
  { code: "OM", name: "Omani", country: "Oman" },
  { code: "PK", name: "Pakistani", country: "Pakistan" },
  { code: "PW", name: "Palauan", country: "Palau" },
  { code: "PS", name: "Palestinian", country: "Palestine" },
  { code: "PA", name: "Panamanian", country: "Panama" },
  { code: "PG", name: "Papua New Guinean", country: "Papua New Guinea" },
  { code: "PY", name: "Paraguayan", country: "Paraguay" },
  { code: "PE", name: "Peruvian", country: "Peru" },
  { code: "PH", name: "Filipino", country: "Philippines" },
  { code: "PL", name: "Polish", country: "Poland" },
  { code: "PT", name: "Portuguese", country: "Portugal" },
  { code: "QA", name: "Qatari", country: "Qatar" },
  { code: "RO", name: "Romanian", country: "Romania" },
  { code: "RU", name: "Russian", country: "Russia" },
  { code: "RW", name: "Rwandan", country: "Rwanda" },
  { code: "KN", name: "Kittian", country: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucian", country: "Saint Lucia" },
  { code: "VC", name: "Saint Vincentian", country: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoan", country: "Samoa" },
  { code: "SM", name: "Sammarinese", country: "San Marino" },
  { code: "ST", name: "Sao Tomean", country: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabian", country: "Saudi Arabia" },
  { code: "SN", name: "Senegalese", country: "Senegal" },
  { code: "RS", name: "Serbian", country: "Serbia" },
  { code: "SC", name: "Seychellois", country: "Seychelles" },
  { code: "SL", name: "Sierra Leonean", country: "Sierra Leone" },
  { code: "SG", name: "Singaporean", country: "Singapore" },
  { code: "SK", name: "Slovak", country: "Slovakia" },
  { code: "SI", name: "Slovenian", country: "Slovenia" },
  { code: "SB", name: "Solomon Islander", country: "Solomon Islands" },
  { code: "SO", name: "Somali", country: "Somalia" },
  { code: "ZA", name: "South African", country: "South Africa" },
  { code: "SS", name: "South Sudanese", country: "South Sudan" },
  { code: "ES", name: "Spanish", country: "Spain" },
  { code: "LK", name: "Sri Lankan", country: "Sri Lanka" },
  { code: "SD", name: "Sudanese", country: "Sudan" },
  { code: "SR", name: "Surinamese", country: "Suriname" },
  { code: "SZ", name: "Swazi", country: "Eswatini" },
  { code: "SE", name: "Swedish", country: "Sweden" },
  { code: "CH", name: "Swiss", country: "Switzerland" },
  { code: "SY", name: "Syrian", country: "Syria" },
  { code: "TW", name: "Taiwanese", country: "Taiwan" },
  { code: "TJ", name: "Tajik", country: "Tajikistan" },
  { code: "TZ", name: "Tanzanian", country: "Tanzania" },
  { code: "TH", name: "Thai", country: "Thailand" },
  { code: "TL", name: "Timorese", country: "Timor-Leste" },
  { code: "TG", name: "Togolese", country: "Togo" },
  { code: "TO", name: "Tongan", country: "Tonga" },
  { code: "TT", name: "Trinidadian", country: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisian", country: "Tunisia" },
  { code: "TR", name: "Turkish", country: "Turkey" },
  { code: "TM", name: "Turkmen", country: "Turkmenistan" },
  { code: "TV", name: "Tuvaluan", country: "Tuvalu" },
  { code: "UG", name: "Ugandan", country: "Uganda" },
  { code: "UA", name: "Ukrainian", country: "Ukraine" },
  { code: "AE", name: "Emirati", country: "United Arab Emirates" },
  { code: "GB", name: "British", country: "United Kingdom" },
  { code: "US", name: "American", country: "United States" },
  { code: "UY", name: "Uruguayan", country: "Uruguay" },
  { code: "UZ", name: "Uzbek", country: "Uzbekistan" },
  { code: "VU", name: "Ni-Vanuatu", country: "Vanuatu" },
  { code: "VA", name: "Vatican", country: "Vatican City" },
  { code: "VE", name: "Venezuelan", country: "Venezuela" },
  { code: "VN", name: "Vietnamese", country: "Vietnam" },
  { code: "YE", name: "Yemeni", country: "Yemen" },
  { code: "ZM", name: "Zambian", country: "Zambia" },
  { code: "ZW", name: "Zimbabwean", country: "Zimbabwe" },
];

export function searchNationalities(query, limit = 8) {
  const q = (query || "").trim().toLowerCase();
  if (q.length < 1) return [];
  const out = [];
  for (const n of NATIONALITIES) {
    if (
      n.name.toLowerCase().startsWith(q) ||
      n.country.toLowerCase().startsWith(q) ||
      n.code.toLowerCase() === q ||
      // also allow substring after the first 3 chars so longer queries still
      // surface matches that aren't at the start (e.g. "kingdom" → United Kingdom)
      (q.length >= 3 && (n.name.toLowerCase().includes(q) || n.country.toLowerCase().includes(q)))
    ) {
      out.push(n);
      if (out.length >= limit) break;
    }
  }
  return out;
}
